import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "../assest_css/footer.css";

function Footer() {
  const displayContacts = () => {
    const contacts = [
      {
        icon: faLinkedin,
        name: "LinkedIn",
        link: "https://www.linkedin.com/in/debbie-urquhart/"
      },
      {
        icon: faEnvelope,
        name: "Email",
        link: "mailto:debiurquhart@live.co.uk"
      },
      {
        icon: faTwitter,
        name: "Twitter",
        link: "https://twitter.com/DebbieCodes"
      },
      {
        icon: faGithub,
        name: "GitHub",
        link: "https://github.com/iamdebi"
      }
    ];
    return contacts.map((contact, index) => {
      return (
        <div key={index} className="panel-icon">
          <a
            href={contact.link}
            target="_blank"
            rel="noreferrer"
            className={`panel-icon-footer ${contact.name}`}
          >
            <FontAwesomeIcon icon={contact.icon} size="2x" />
            <p>{contact.name}</p>
          </a>
        </div>
      );
    });
  };

  return (
    <footer>
      <section className="container contacts" id="contact">
        <h2 className="heading">Contact</h2>
        <div className="container-panel-icon">{displayContacts()}</div>
      </section>
    </footer>
  );
}

export default Footer;
